<template>
  <div class="login">
    <img
      class="login--background"
      src="@/assets/images/login/background-login-v5.png"
    />
    <div class="box-login">
      <div class="box-login--header">
        <img
          class="box-login--header__image"
          src="@/assets/images/letsbook-icon.svg"
        />
      </div>
      <div class="box-login--body">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseLayoutLogin'
}
</script>

<style lang="scss" scoped>
.login {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100vh;
  max-height: 100%;
  overflow: auto;
  background: #ededec;
  padding: 0px 200px;

  @media screen and (max-width: 1000px) {
    padding: 0px;
    justify-content: center;
  }

  &--background {
    position: fixed;
    min-height: 100%;
    max-width: 100%;
    z-index: 0;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    @media screen and (max-width: 1000px) and (max-height: 1368px) {
      min-width: 225%;
      max-width: 0%;
    }

    @media screen and (max-width: 1000px) and (max-height: 900px) {
      min-width: 120%;
      max-width: 0%;
    }

    @media screen and (max-width: 550px) {
      min-width: 300%;
      max-width: 0%;
    }
  }

  .box-login {
    background: $white;
    width: 300px;
    z-index: 1;
    @include box-shadow(4px 4px 15px rgba(0, 0, 0, 0.1));

    &--header {
      padding: 18px 0px 17px 0px;
      background: pmw-colors('primary-100');

      &__image {
        max-width: 100px;
        margin: 0px auto;
        display: block;
      }
    }
  }
}
</style>
